"use strict";const t="data-bs-toggle";exports.dataBsToggle=t;
//# sourceMappingURL=dataBsToggle-Dj-Ng54N.js.map
